import { Box, Typography } from "@mui/material";
import "./CreateSummaryCard.css";
import { VehicleOption } from "./types";
import { truncateToTwoDecimals } from "../../dms_common/DmsUtils";

interface CreateSummaryCardProps {
  title: string;
  box?: VehicleOption[] | undefined;
}

const LABELS = [
  "Total vehicle capacity",
  "Consumed capacity",
  "Balance capacity",
];

export default function CreateSummaryCard({
  title,
  box,
}: CreateSummaryCardProps) {
  return (
    <div className="CreateSummary_card-container">
      <div className="cart-title-box">
        <Typography className="card-title">{title}</Typography>
      </div>
      <Box sx={{ width: "86.5%", display: "flex" }}>
        {box?.map((item, index) => {
          const isKgNegative = (item?.vehicleCapacityKG ?? 0) < 0;
          const isCubicNegative = (item?.vehicleCapacityCubicFeet ?? 0) < 0;

          const renderValue = (val: number) => truncateToTwoDecimals(val);

          return (
            <div
              className="summaryCardbox-container"
              key={index}
              style={{
                padding:
                  renderValue(item?.vehicleCapacityKG ?? 0)
                    ?.toString()
                    .replace(".", "").length > 6 ||
                  renderValue(item?.vehicleCapacityCubicFeet ?? 0)
                    ?.toString()
                    .replace(".", "").length > 6
                    ? "0 1.5%"
                    : "",
              }}
            >
              <Typography
                sx={{
                  fontSize: "12px",
                  fontWeight: 500,
                  mb: "5px",
                  letterSpacing: 0,
                }}
              >
                {LABELS[index] ?? ""}
              </Typography>
              <div
                className="summaryCardInnerbox-container"
                style={{
                  backgroundColor:
                    isKgNegative || isCubicNegative ? "#FFF9F8" : "",
                }}
              >
                <div
                  className="summaryCardWhiteContainer"
                  style={{
                    border: isKgNegative ? "1px solid #C44C36" : "",
                  }}
                >
                  <Typography
                    className="kgcm3Value"
                    style={{ color: isKgNegative ? "#C44C36" : "" }}
                  >
                    {renderValue(item?.vehicleCapacityKG ?? 0)}
                  </Typography>
                  <Typography
                    className="kgcm3Unit"
                    style={{ color: isKgNegative ? "#C44C36" : "" }}
                  >
                    Kg
                  </Typography>
                </div>
                <div
                  className="summaryCardWhiteContainer"
                  style={{
                    border: isCubicNegative ? "1px solid #C44C36" : "",
                  }}
                >
                  <Typography
                    className="kgcm3Value"
                    style={{ color: isCubicNegative ? "#C44C36" : "" }}
                  >
                    {renderValue(item?.vehicleCapacityCubicFeet ?? 0)}
                  </Typography>
                  <Typography
                    className="kgcm3Unit"
                    style={{ color: isCubicNegative ? "#C44C36" : "" }}
                  >
                    cm<sup style={{ fontSize: "0.59rem" }}>3</sup>
                  </Typography>
                </div>
              </div>
            </div>
          );
        })}
      </Box>
    </div>
  );
}
